import Color from "color";
import lodashPick from "lodash.pick";
import { Children, isValidElement } from "react";
export { transparentize } from "@chakra-ui/theme-tools";
export const lighten = (color, amount) => Color(color).lighten(amount).hex();
export const darken = (color, amount) => Color(color).darken(amount).hex();
export const generateColorPalette = (color) => ({
    900: darken(color, 0.7),
    800: darken(color, 0.5),
    700: darken(color, 0.3),
    600: darken(color, 0.15),
    500: color,
    400: lighten(color, 0.15),
    300: lighten(color, 0.3),
    200: lighten(color, 0.5),
    100: lighten(color, 0.7),
    50: lighten(color, 0.88),
});
export function pick(obj, args) {
    return lodashPick(obj, args);
}
export function getValidChildren(children) {
    return Children.toArray(children).filter((child) => isValidElement(child));
}
// Split time string to return [value: number, unit: string]
export function splitTimeUnit(time) {
    var _a, _b;
    const timeRegex = /^([\d.]+)([a-zA-Z]+)$/;
    const match = time.match(timeRegex);
    return [(_a = Number(match === null || match === void 0 ? void 0 : match[1])) !== null && _a !== void 0 ? _a : 0, (_b = match === null || match === void 0 ? void 0 : match[2]) !== null && _b !== void 0 ? _b : "ms"];
}
//# sourceMappingURL=index.js.map